import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task, dropTask } from 'ember-concurrency';
import ticketCategoryEmailChangeset from 'garaje/changesets/ticket-category-email';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import isValidUrl from 'garaje/utils/is-valid-url';
import { all, defer } from 'rsvp';
let RoomServiceRequestComponent = (_class = class RoomServiceRequestComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "graphql", _descriptor, this);
    _initializerDefineProperty(this, "featureFlags", _descriptor2, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor3, this);
    _initializerDefineProperty(this, "metrics", _descriptor4, this);
    _initializerDefineProperty(this, "store", _descriptor5, this);
    _initializerDefineProperty(this, "isOpen", _descriptor6, this);
    _initializerDefineProperty(this, "ticketConfiguration", _descriptor7, this);
    _initializerDefineProperty(this, "ticketCategoryEmailChangesets", _descriptor8, this);
    _initializerDefineProperty(this, "newTicketCategoryEmailChangesets", _descriptor9, this);
    _initializerDefineProperty(this, "documentationLink", _descriptor10, this);
    _initializerDefineProperty(this, "urlErrors", _descriptor11, this);
    _defineProperty(this, "deleteTicketCategoryTask", _buildTask(() => ({
      context: this,
      generator: function* (ticketCategory) {
        try {
          const location = this.args.location;
          yield ticketCategory.destroyRecord();
          this.flashMessages.showAndHideFlash('success', 'Success!', `"${ticketCategory.name}" category was deleted`);
          this.metrics.trackEvent('Ticketing category deleted', {
            locationId: location.id
          });
        } catch (error) {
          this.flashMessages.showFlash('error', parseErrorForDisplay(error));
        }
      }
    }), {
      drop: true
    }, "deleteTicketCategoryTask", null));
    _defineProperty(this, "saveEmailsTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const changesetsToSave = this.allEmailChangesets.filter(changeset => changeset.isDirty || changeset.data.isDeleted);
          yield all(changesetsToSave.map(changeset => changeset.save()));
          yield this.ticketConfiguration?.save();
          this.flashMessages.showAndHideFlash('success', 'Success!');
          this.toggleOpen();
        } catch (e) {
          this.flashMessages.showFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "saveEmailsTask", null));
    _defineProperty(this, "enableTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const location = this.args.location;
          this.ticketConfiguration = this.ticketConfiguration || this.store.createRecord('ticket-configuration', {
            location
          });
          this.ticketConfiguration.enabled = true;
          yield this.ticketConfiguration.save();
          this.flashMessages.showAndHideFlash('success', 'Ticketing enabled successfully!');
          this.metrics.trackEvent('Ticketing enabled', {
            locationId: location.id
          });
          this.toggleOpen();
        } catch (e) {
          this.flashMessages.showFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "enableTask", null));
    _defineProperty(this, "disableTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const location = this.args.location;
          if (this.ticketConfiguration) {
            this.ticketConfiguration.enabled = false;
            yield this.ticketConfiguration.save();
          }
          this.flashMessages.showAndHideFlash('success', 'Ticketing disabled!');
          this.metrics.trackEvent('Ticketing disabled', {
            locationId: location.id
          });
          this.toggleOpen();
        } catch (e) {
          this.flashMessages.showFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "disableTask", null));
    _defineProperty(this, "loadTicketingConfigurationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const locationId = this.args.location.id;
        const roomConfigType = 'RoomTicketConfiguration';
        const filter = {
          location: locationId,
          type: roomConfigType
        };
        try {
          const response = yield this.store.query('ticket-configuration', {
            filter,
            include: 'ticket-categories,ticket-category-emails.ticket-category'
          });
          this.ticketConfiguration = response.firstObject;
          this.documentationLink = this.ticketConfiguration?.serviceRequestUrl || '';
        } catch (e) {
          this.flashMessages.showFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "loadTicketingConfigurationTask", null));
    _initializerDefineProperty(this, "confirmTicketDeletionModalTask", _descriptor12, this);
    _initializerDefineProperty(this, "showCreateTicketModalTask", _descriptor13, this);
  }
  get saveButtonEnabled() {
    const allValid = this.allEmailChangesets.every(changeset => changeset.isValid);
    const anyDirtyOrDeletedEmails = this.allEmailChangesets.some(changeset => changeset.isDirty || changeset.data.isDeleted);
    const anyDirtyOrDeletedFields = anyDirtyOrDeletedEmails || (this.ticketConfiguration?.hasDirtyAttributes ?? false);
    return allValid && anyDirtyOrDeletedFields && this.urlErrors.length == 0;
  }
  get allEmailChangesets() {
    return [...this.ticketCategoryEmailChangesets, ...this.newTicketCategoryEmailChangesets];
  }
  get ticketCategories() {
    return this.ticketConfiguration?.ticketCategories.filter(category => !category.isNew);
  }
  onDeleteTicketCategory(changesetToDelete) {
    // @ts-ignore for some reason the linter thinks isNew is a function
    if (changesetToDelete.data.isNew) {
      this.newTicketCategoryEmailChangesets = this.newTicketCategoryEmailChangesets.filter(changeset => changeset !== changesetToDelete);
    } else {
      changesetToDelete.data.deleteRecord();
    }
  }
  addAnotherEmail() {
    const newTicketEmail = this.store.createRecord('ticket-category-email', {
      ticketConfiguration: this.ticketConfiguration
    });
    this.newTicketCategoryEmailChangesets = [...this.newTicketCategoryEmailChangesets, ticketCategoryEmailChangeset(newTicketEmail)];
  }
  didInsertPanel() {
    void this.loadTicketingConfigurationTask.perform();
  }
  didInsertContent() {
    if (this.ticketConfiguration) {
      this.ticketCategoryEmailChangesets = this.ticketConfiguration.ticketCategoryEmails.toArray().map(ticketEmail => {
        return ticketCategoryEmailChangeset(ticketEmail);
      });
      if (this.ticketCategoryEmailChangesets.length === 0) {
        this.addAnotherEmail();
      }
    }
  }
  willDestroyContent() {
    this.ticketCategoryEmailChangesets = [];
    this.newTicketCategoryEmailChangesets = [];
    this.ticketConfiguration?.ticketCategoryEmails.toArray().forEach(ticketEmail => {
      // @ts-ignore for some reason the linter thinks isNew is a function
      if (ticketEmail.isNew) {
        this.store.unloadRecord(ticketEmail);
      }
    });
  }
  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
  edit() {
    if (!this.ticketConfiguration || !this.ticketConfiguration.enabled) {
      void this.enableTask.perform();
    } else {
      this.toggleOpen();
    }
  }
  updateDocumentationLink(value) {
    this.documentationLink = value;
    if (!value || isValidUrl(value)) {
      this.urlErrors = [];
      if (this.ticketConfiguration) {
        this.ticketConfiguration.serviceRequestUrl = value;
      }
    } else {
      this.urlErrors = ['Please enter a valid URL'];
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "featureFlags", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ticketConfiguration", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "ticketCategoryEmailChangesets", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "newTicketCategoryEmailChangesets", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "documentationLink", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "urlErrors", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "onDeleteTicketCategory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDeleteTicketCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addAnotherEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addAnotherEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didInsertPanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsertPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didInsertContent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsertContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willDestroyContent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "willDestroyContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "edit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "edit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateDocumentationLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateDocumentationLink"), _class.prototype), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "confirmTicketDeletionModalTask", [dropTask], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      *perform(category) {
        const deferred = defer();
        this.abort = () => {
          deferred.resolve(false);
        };
        this.continue = async () => {
          let {
            ticketCategoryEmailChangesets,
            newTicketCategoryEmailChangesets
          } = this.context;
          const {
            deleteTicketCategoryTask
          } = this.context;
          // Remove the category from the list of ticket categories
          const changesetsToDelete = ticketCategoryEmailChangesets.filter(changeset => changeset.ticketCategory?.id === category.id);
          const newChangesetsToDelete = newTicketCategoryEmailChangesets.filter(changeset => changeset.ticketCategory?.id === category.id);
          await deleteTicketCategoryTask.perform(category);
          changesetsToDelete.forEach(changesetToDelete => {
            ticketCategoryEmailChangesets = ticketCategoryEmailChangesets.filter(changeset => changeset !== changesetToDelete);
          });
          newChangesetsToDelete.forEach(newChangesetToDelete => {
            newTicketCategoryEmailChangesets = newTicketCategoryEmailChangesets.filter(changeset => changeset !== newChangesetToDelete);
          });
          deferred.resolve(true);
        };
        return yield deferred.promise;
      }
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showCreateTicketModalTask", [dropTask], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      *perform() {
        const deferred = defer();
        this.abort = () => {
          deferred.resolve(false);
        };
        this.continue = () => {
          deferred.resolve(true);
        };
        return yield deferred.promise;
      }
    };
  }
})), _class);
export { RoomServiceRequestComponent as default };